import * as yup from "yup";

export const formBuilderValidation = yup.object({
  name: yup.string().required(),
  recipients: yup.string().required(),
});
